"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var trmAuth = exports.trmAuth = {
	pathesToCheck: ["auth"],
	tr: {
		auth: {
			AuthManagerUserPasswordWrongException: {
				"DE": "Username oder Passwort falsch.",
				"EN": "Username or password wrong."
			},
			AuthManagerCredentialServerException: {
				"DE": "Anmeldeserver ist nicht verfügbar",
				"EN": "Credentialserver ist not available."
			},
			LoginNotEnabledException: {
				"DE": "Bitte aktivieren Sie Ihren Account durch den Link in der Bestätigungs-EMail.",
				"EN": "Please activate your account by clicking the link on your Activate-Email."

			},
			AuthManagerUnknownErrorException: {
				"DE": "Unbekannter Fehler",
				"EN": "Unknown error."
			}
		}
	}
};